module.exports = __webpack_public_path__ + "img/05.2545d7d8.svg";